// using ES6 modules
import lozad from 'lozad';

const observer = lozad('.lozad', {
    rootMargin: '0px 0px 400px 0px',
    threshold: 0
});

/**
 * LazyLoad()
 * @desc - Call this to register lazy loading for elements with .lozad
 */
export default () => {
    //just keep calling me to add new lazy load elements
    observer.observe();
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/boot/lazy-load.js